import { Inbox, Loader2 } from "lucide-react";
import type { NotificationItem } from "@/lib/notification.api";
import { NotificationRow } from "./NotificationRow";

export function NotificationList({
  notifications,
  isLoading,
  dismissingId,
  dismissing,
  onOpen,
  onDismiss,
}: {
  notifications: NotificationItem[];
  isLoading: boolean;
  dismissingId?: number;
  dismissing: boolean;
  onOpen: (item: NotificationItem) => void;
  onDismiss: (id: number) => void;
}) {
  return (
    <div className="divide-y divide-neutral-100">
      {isLoading ? (
        <div className="flex h-44 items-center justify-center">
          <Loader2 className="animate-spin text-subtle" size={18} />
        </div>
      ) : notifications.length === 0 ? (
        <div className="px-4 py-12 text-center">
          <Inbox className="mx-auto text-subtle" size={24} />
          <p className="mt-3 text-[13px] font-medium text-body">Aucune notification</p>
          <p className="mt-1 text-[12px] text-muted-foreground">
            Les alertes système apparaîtront ici dès qu'un événement sera détecté.
          </p>
        </div>
      ) : (
        notifications.map((item) => (
          <NotificationRow
            key={item.id}
            item={item}
            onOpen={onOpen}
            onDismiss={onDismiss}
            dismissing={dismissingId === item.id && dismissing}
          />
        ))
      )}
    </div>
  );
}
